import DispatcherEvent from '@carvana/merch-native/DispatcherEvent';
import { NativeModalId } from '~/context/home/ModalContext/constants';
import sendMessageToNative from './sendMessageToNative';

export default function sendMessageToOpenNativeModal(modal: NativeModalId) {
  sendMessageToNative(DispatcherEvent.OpenModal, { modal });
}
